import * as React from "react";
import { SvgIcon } from "@mui/material";
import { IconProps } from "./_interface";

const SvgNotificationIcon = (props: IconProps) => {
  return (
    <SvgIcon {...props} color="inherit" viewBox="0 0 20 24">
      <path d="M10.0003 23.667C11.2837 23.667 12.3337 22.617 12.3337 21.3337H7.66699C7.66699 22.617 8.70532 23.667 10.0003 23.667ZM17.0003 16.667V10.8337C17.0003 7.25199 15.087 4.25366 11.7503 3.46033V2.66699C11.7503 1.69866 10.9687 0.916992 10.0003 0.916992C9.03199 0.916992 8.25032 1.69866 8.25032 2.66699V3.46033C4.90199 4.25366 3.00033 7.24033 3.00033 10.8337V16.667L0.666992 19.0003V20.167H19.3337V19.0003L17.0003 16.667Z" fill="currentColor" fillRule="evenodd"/>
    </SvgIcon>
  );
};

export default SvgNotificationIcon;
